<div class="z-[1000] fixed top-0 left-5 right-0 bottom-0 min-h-full w-full table-cell align-middle overflow-auto pl-0">
    <div class="relative top-1 px-1.5 mr-5 min-w-[70px] text-corporate-3 font-bold bg-modal box-border border border-shadow-bg rounded-md min-h-[20%] text-[13px] max-w-[600px] leading-[26px] mb-0 h-auto flex flex-col" cdkDrag>
        <div class="bg-modal p-2.5 min-h-[50px] text-label">
            <h1 class="leading-[1.2] m-0 mb-2.5 text-center border-b border-border pb-2.5 pt-2.5 text-corporate-3 text-base">Opciones de Evento Periódico</h1>
            <p class="mx-auto mb-[-1px] p-[5px] pb-[7px] w-[95%] text-base text-label">Existen múltiples eventos en esta serie. ¿Qué eventos deseas cambiar?</p>
        </div>
        <div class="text-center mb-2.5">
            <a class="text-left w-[90%] flex flex-row mx-auto mb-[-1px] min-h-[70px] p-[5px] pb-[7px] bg-form-bg border border-border text-label cursor-pointer rounded-[3px]" href="#" (click)="action($event,'onlyThisEvent')">
               <div class="flex flex-col max-w-[95px] min-w-[95px]">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" class="w-[60px] h-[60px] pl-2.5">
                    <g fill="none" fill-rule="evenodd">
                    <circle cx="7" cy="33" r="3" fill="#22BA8E" id="id_101"></circle>
                    <circle cx="20" cy="33" r="3" fill="#22BA8E" id="id_102"></circle>
                    <circle cx="33" cy="33" r="3" fill="#0a6c80" id="id_103"></circle>
                    <circle cx="46" cy="33" r="3" fill="#22BA8E" id="id_104"></circle>
                    <circle cx="59" cy="33" r="3" fill="#22BA8E" id="id_105"></circle>
                    </g>
                </svg>
                <span class="relative bottom-4 mx-auto mb-[-1px] px-2.5 py-[5px] pb-[7px] w-[95%] text-base text-label">Único</span>
               </div>
                <div class="mx-auto mb-[-1px] px-2.5 py-[5px] pb-[7px] w-[95%] text-base text-label">
                    <p>{{messageA}}</p>
                    <!--<p> "Aplicar únicamente a este evento."</p>-->
                </div>
            </a>
            <a class="text-left w-[90%] flex flex-row mx-auto mb-[-1px] min-h-[70px] p-[5px] pb-[7px] bg-form-bg border border-border text-label cursor-pointer rounded-[3px]" href="#" (click)="action($event,'allEvents')">
                <div class="flex flex-col max-w-[95px] min-w-[95px]">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" class="w-[60px] h-[60px] pl-2.5">
                    <g fill="none" fill-rule="evenodd">
                    <circle cx="7" cy="33" r="3" fill="#046b80" id="id_106"></circle>
                    <circle cx="20" cy="33" r="3" fill="#036b80" id="id_107"></circle>
                    <circle cx="33" cy="33" r="3" fill="#086c80" id="id_108"></circle>
                    <circle cx="46" cy="33" r="3" fill="#056c80" id="id_109"></circle>
                    <circle cx="59" cy="33" r="3" fill="#036b80" id="id_110"></circle>
                    </g>
                    </svg>
                    <span class="relative bottom-4 mx-auto mb-[-1px] px-2.5 py-[5px] pb-[7px] w-[95%] text-base text-label">Todos</span>
                </div>
                <div class="mx-auto mb-[-1px] px-2.5 py-[5px] pb-[7px] w-[95%] text-base text-label">
                    <p>{{messageB}}</p>
                   <!----<p> "Aplicar a todos los eventos de la serie."</p>-->
                </div>
            </a>
            <a class="text-left w-[90%] flex flex-row mx-auto mb-[-1px] min-h-[70px] p-[5px] pb-[7px] bg-form-bg border border-border text-label cursor-pointer rounded-[3px]" href="#" (click)="action($event,'thisEventAndLater')">
                <div class="flex flex-col max-w-[95px] min-w-[95px]">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" class="w-[60px] h-[60px] pl-2.5">
                    <g fill="none" fill-rule="evenodd">
                    <circle cx="7" cy="33" r="3" fill="#22BA8E" id="id_106"></circle>
                    <circle cx="20" cy="33" r="3" fill="#22BA8E" id="id_107"></circle>
                    <circle cx="33" cy="33" r="3" fill="#086c80" id="id_108"></circle>
                    <circle cx="46" cy="33" r="3" fill="#056c80" id="id_109"></circle>
                    <circle cx="59" cy="33" r="3" fill="#036b80" id="id_110"></circle>
                    </g>
                    </svg>
                    <span class="relative bottom-4 mx-auto mb-[-1px] px-2.5 py-[5px] pb-[7px] w-[95%] text-base text-label">Siguientes</span>
                </div>
               <div class="mx-auto mb-[-1px] px-2.5 py-[5px] pb-[7px] w-[95%] text-base text-label">
                <p>{{messageC}}</p>
               <!----<p> "Aplicar a este evento y a los siguientes."</p>-->
               </div>
            </a>

        </div>
        <p class="text-right border-t border-border pt-2.5">
            <button class="flex flex-row float-right leading-[18px] h-[33px] text-[15px] font-bold text-left box-border px-2 py-[5px] rounded-md mr-2.5 mt-0 cursor-pointer pl-[5px] ml-[3px] text-save-btn-font border border-border bg-error" (click)="closeModal()">
                <lucide-icon name="x" [size]="24" class="relative -top-0.5 -left-[5px] float-left"></lucide-icon>
                <span class="text-left">Cancelar</span>
           </button>
        <p>
    </div>


</div>